module.exports = __webpack_public_path__ + "img/workContents03_pc_04.b862eb8b.png";